import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { useTrail } from 'react-spring';

import { Product } from '../interfaces';
import ProductCard from './ProductCard';

const useStyles = createUseStyles({
    productList: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: '1rem -.5rem',
        '& > *': {
            margin: '.5rem',
            maxWidth: '100%',
            flex: '1 1 400px',
            '@media (min-width: 960px)': {
                maxWidth: 'calc(50% - 1rem)'
            }
        }
    }
});

interface ProductListProps {
    products: Product[];
}

const ProductList: React.FC<ProductListProps> = ({ products }: ProductListProps) => {
    const classes = useStyles();

    const transitions = useTrail(products.length, {
        from: { opacity: 0, transform: `translateY(20%)` },
        config: { mass: 5, tension: 2000, friction: 200 },
        transform: `translateY(0%)`,
        opacity: 1
    });

    return (
        <div className={classes.productList}>
            {transitions.map((props, index) => (
                <ProductCard key={products[index].identifier} product={products[index]} style={props} />
            ))}
        </div>
    );
};

export default React.memo(ProductList);
